import { type ICreateResult, type IUpdateResultData } from '@/helpers/types';

import { queryApiSlice } from '../apiSlice';

export const resultQueryApiSlice = queryApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createResult: builder.mutation<unknown, ICreateResult>({
			query: (body) => ({
				url: '/Result',
				method: 'POST',
				body,
			}),
		}),
		getResult: builder.query<unknown, { query?: string }>({
			query: ({ query }) => `/Result${query || ''}`,
		}),
		uploadResult: builder.mutation<unknown, FormData>({
			query: (body) => ({
				url: '/Result/upload-result',
				method: 'POST',
				body,
			}),
		}),
		pushResultData: builder.mutation<unknown, FormData>({
			query: (body) => ({
				url: '/Result/push-result-data',
				method: 'POST',
				body,
			}),
		}),
		pushResultDataModel: builder.mutation<unknown, FormData>({
			query: (body) => ({
				url: '/Result/push-result-data-model',
				method: 'POST',
				body,
			}),
		}),
		seedResults: builder.query<unknown, undefined>({
			query: () => '/Result/seed-results',
		}),
		updateResultStatus: builder.mutation<unknown, { id: string; status: string; comment: string }>({
			query: (body) => ({
				url: '/Result/update-result_status',
				method: 'POST',
				body,
			}),
		}),
		updateResultData: builder.mutation<unknown, IUpdateResultData>({
			query: (body) => ({
				url: '/Result/update-result_data',
				method: 'POST',
				body,
			}),
		}),
		checkResultRequest: builder.query<unknown, { query?: string }>({
			query: ({ query }) => `/ZipResultRequest/get-all-paged${query || ''}`,
		}),
	}),
});

export const {
	useCreateResultMutation,
	useLazyGetResultQuery,
	useUploadResultMutation,
	usePushResultDataMutation,
	usePushResultDataModelMutation,
	useLazySeedResultsQuery,
	useUpdateResultStatusMutation,
	useUpdateResultDataMutation,
	useLazyCheckResultRequestQuery,
} = resultQueryApiSlice;
